import React from 'react';
import { Descriptions } from 'antd';
import moment from 'moment';
import { DeliveryStatusSummary } from '../../Types/RouteDetails.types';

interface RouteInformationProps {
  routeDetails: any;
  deliveryStatus: DeliveryStatusSummary;
  routeAdherence: string;
}

const RouteInformation = ({ routeDetails, deliveryStatus, routeAdherence }: RouteInformationProps): JSX.Element => (
  <Descriptions title="Route Information" bordered column={3}>
    <Descriptions.Item label="Date" span={1}>
      {routeDetails.optimized_date ? moment(routeDetails.optimized_date).format('YYYY-MM-DD HH:mm:ss') : 'N/A'}
    </Descriptions.Item>
    <Descriptions.Item label="Vehicle Number" span={1}>
      {routeDetails.vehicle_number}
    </Descriptions.Item>
    <Descriptions.Item label="Total Locations" span={1}>
      {routeDetails.number_of_locations}
    </Descriptions.Item>

    <Descriptions.Item label="Delivered Locations" span={1}>
      {deliveryStatus.delivered}
    </Descriptions.Item>
    <Descriptions.Item label="Pending Locations" span={1}>
      {deliveryStatus.pending}
    </Descriptions.Item>
    <Descriptions.Item label="Skipped Locations" span={1}>
      {deliveryStatus.skipped}
    </Descriptions.Item>

    <Descriptions.Item label="Actual Distance" span={1}>
      {Math.round(routeDetails.actual_distance)} Km
    </Descriptions.Item>
    <Descriptions.Item label="Optimized Distance" span={1}>
      {Math.round(routeDetails.optimized_distance)} Km
    </Descriptions.Item>
    <Descriptions.Item label="Route Adherence" span={1}>
      {routeAdherence}
    </Descriptions.Item>
  </Descriptions>
);

export default RouteInformation;
